import React, { Suspense } from "react";
import styled from "styled-components";
import t from "common/i18n";
import Progress from "root/components/Progress/Progress";
const MetadataForm = React.lazy(() => import("@cld/metadata-form"));

const LazyMetadataForm = styled.div`
	margin-top: ${({ theme }) => `${theme?.spacing?.md}`};
`;

export default ({ fields, layout, handleFormSubmitSuccess, hasConflicts, handleFormError, formRef }) =>
	<LazyMetadataForm>
		<Suspense fallback={<Progress size="lg"/>}>
			<MetadataForm
				fields={fields}
				layout={layout}
				onSubmit={handleFormSubmitSuccess}
				conflictHandleLabel={hasConflicts ? t("metadataPage.conflict_label") : undefined}
				onError={handleFormError}
				ref={formRef}
			/>
		</Suspense>
	</LazyMetadataForm>;
